import router from '@/router';
import localStorage from '@/services/storage';
import api from '@/services/api';

export default {
    /**
     * Attempts to login a user via username and passowrd
     *
     * @param context
     * @param {object} authData
     */
    login(context , authData) {
        const params = new URLSearchParams();
        params.append('email', authData.username);
        params.append('password', authData.password);
        api.post('/api/auth/login', params)
            .then((response) => {
                const token = response.data.body.token;
                context.commit('STORE_USER', {
                    token,
                    user: response.data.body.user,
                });
                localStorage.save('token', token.token, true);
                router.replace('/home');
            }).then(()=> {
            // Get active promotion
            context.dispatch('promotion/storePromotion', {}, {root: true});
        })
            .catch((error) => {
                context.commit('SHOW_LOGIN_ERRORS', error.response.data);
            });
    },

    /**
     * Attempts to logout user
     *
     * @param {object} state
     */
    logout({ commit }) {
        api.get('/api/auth/logout')
            .then((response) => {
                commit('CLEAR_AUTH_DATA');
                localStorage.clear()
            });

        router.replace('/');
    },

    /**
     * Checks if user is logged in (has valid token)
     *
     * @param context
     * @param payload
     * @return  {void}
     */
    tryAutoLogin(context, payload) {
        api.get('/api/auth/me')
            .then((response) => {
                context.commit('STORE_USER', {
                    token: payload.token,
                    user: response.data.body.user,
                });
            }).then(() => {
            // Get active promotion
            context.dispatch('promotion/storePromotion', {}, {root: true});
        })
            .catch(() => {
                // Token expired or invalid token
                localStorage.remove('token');
            });
    },
};
